<template>
  <div>
    <location />
    <div class="page">
      <tab />
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-1"
          role="tabpanel"
          aria-labelledby="pills-1-tab"
        >
          <div class="wrap-1200">
            <b-form
              @submit="onSubmit"
              class="filter-group row row-cols-2 row-cols-md-auto g-2 justify-content-end"
            >
              <div class="col-12 col-sm-6 col-md-auto">
                <select
                  aria-label="Select one"
                  name="searchtype"
                  v-model="searchData.searchtype"
                >
                  <option value="O.nickname">
                    {{ $t("title.common.location") }}
                  </option>
                  <!-- <option value="2">매장명</option> -->
                  <!-- <option value="CM.title">{{ $t("filter.common.course") }}</option> -->
                </select>
              </div>
              <div class="col-12 col-sm-6 col-md-auto">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    name="searchname"
                    v-model="searchData.searchname"
                  />
                  <button
                    class="btn btn-primary btn-md icon-search"
                    type="submit"
                  ></button>
                </div>
              </div>
            </b-form>

            <table class="table board">
              <thead>
                <tr>
                  <th class="col-auto d-none d-lg-table-cell">
                    {{ $t("title.common.reservation_number") }}
                  </th>
                  <th class="col-auto d-lg-table-cell">
                    {{ $t("title.common.reservation_date") }}
                  </th>
                  <th class="col-auto d-none d-lg-table-cell w-1">
                    {{ $t("title.common.location") }}
                  </th>
                  <th class="col-auto d-none d-lg-table-cell w-1">
                    {{ $t("title.common.peoples") }}
                  </th>
                  <th class="col-auto d-none d-lg-table-cell">
                    {{ $t("title.common.status") }}
                  </th>

                  <th class="col-auto d-none d-sm-table-cell">
                    {{ $t("title.common.date") }}
                  </th>
                  <th class="th-arrow">&nbsp;</th>
                </tr>
              </thead>
              <tbody v-if="total_cnt > 0">
                <template v-for="(item, index) in items">
                  <tr class="table-row" :key="index" @click="reservation_detail(item)">
                    <td
                      class="col-auto d-none d-lg-table-cell text-start text-lg-center shop-name"
                    >
                      {{ item.rsv_pk }}
                    </td>
                    <td
                      class="col-auto d-lg-table-cell text-start"
                    >
                      <template
                        v-if="item.timezone_start_date.timezone_private"
                      >
                        <p class="text-date text-nowrap">
                          <dfn
                            class="time-zone-mark badge rounded-pill bg-orange"
                            title="Connect time"
                            >CT</dfn
                          >
                          {{
                            item.timezone_start_date.timezone_private
                              | dateformat
                          }}
                          ~
                          {{
                            item.timezone_end_date.timezone_private | dateformat
                          }}
                        </p>
                      </template>
                    </td>
                    <td class="col-auto d-none d-lg-table-cell">
                      {{ item.shopname }}
                    </td>
                    <td class="col-auto d-none d-lg-table-cell">
                      {{ item.people }} {{ $t("text.common.people") }}
                    </td>

                    <td class="col-auto d-none d-lg-table-cell">
                      {{ item.status | reservation_status }}
                    </td>

                    <td class="col-auto d-none d-lg-table-cell">
                      <template v-if="item.timezone_regdate.timezone_private">
                        <p class="text-date text-nowrap">
                          <dfn
                            class="time-zone-mark badge rounded-pill bg-orange"
                            title="Connect time"
                            >CT</dfn
                          >
                          {{
                            item.timezone_regdate.timezone_private | dateformat
                          }}
                        </p>
                      </template>
                      <!-- 서비스 시간 -->
                    </td>

                    <td class="td-arrow" @click="toggle_tr(index)">
                      <img
                        src="/img/arrow_none_collapsed.png"
                        :class="{ 'btn-toggle-arrow': view_hide === index }"
                      />
                    </td>
                  </tr>
                  <tr
                    class="d-lg-none"
                    :class="{ show: view_hide === index }"
                    :key="index + 'r'"
                    v-if="view_hide === index"
                  >
                    <td colspan="7">
                      <div class="toggle-content">
                        <div class="row">
                          <div class="col-4">
                            {{ $t("title.common.reservation_number") }}
                          </div>
                          <div class="col-8">
                            {{ item.rsv_pk }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                            {{ $t("title.common.peoples") }}
                          </div>
                          <div class="col-8">
                            {{ item.people }} {{ $t("text.common.people") }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                            {{ $t("title.common.status") }}
                          </div>
                          <div class="col-8">
                            {{ item.status | reservation_status }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-4">{{ $t("title.common.date") }}</div>
                          <div class="col-8">
                            <template
                              v-if="item.timezone_regdate.timezone_private"
                            >
                              <p class="text-date text-nowrap">
                                <dfn
                                  class="time-zone-mark badge rounded-pill bg-orange"
                                  title="Connect time"
                                  >CT</dfn
                                >
                                {{
                                  item.timezone_regdate.timezone_private
                                    | dateformat
                                }}
                              </p>
                            </template>
                            <!-- 서비스 시간 -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" class="text-center">
                    {{ $t("text.common.no_data") }}
                  </td>
                </tr>
              </tbody>
            </table>

            <b-pagination-nav
              :link-gen="linkGen"
              :number-of-pages="page_total"
              v-model="searchData.pageno"
              use-router
              aria-label="Page navigation"
              v-if="page_total > 1"
              first-class="prev"
              prev-class="prev"
              next-class="next"
              last-class="next"
              hide-ellipsis
              limit="10"
            >
              <template #first-text>
                <i class="material-icons">keyboard_double_arrow_left</i>
              </template>
              <template #prev-text>
                <i class="material-icons">navigate_before</i>
              </template>
              <template #next-text>
                <i class="material-icons">navigate_next</i>
              </template>
              <template #last-text>
                <i class="material-icons">keyboard_double_arrow_right</i>
              </template>
              <template #page="{ page, active }">
                <a v-if="active">{{ page }}</a>
                <a v-else>{{ page }}</a>
              </template>
            </b-pagination-nav>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-reservation"
      ref="modal-reservation"
      size="md"
      centered
      scrollable
      no-close-on-backdrop
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h3>{{ $t("title.common.reservation") }}</h3>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-reservation')"
        >
        </b-button>
      </template>
      <template>
        <p class="modal-subtitle lh-sm">
          {{ $t("title.common.reservation") }}
          {{ $t("title.common.Information") }}
        </p>
        <b-form
          class="filter-group row row-cols-sm-auto g-2 justify-content-end"
        >
          <div class="row g-0 table-type header-col p-keep">
            <div class="col-sm-4">
              <span>{{ $t("title.common.nickname") }}</span>
            </div>
            <div class="col-sm-8">
              {{ item.nickname }}
            </div>

            <div class="col-sm-4">
              <span>{{ $t("title.common.email") }}</span>
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              {{ item.email }}
            </div>

            <div class="col-sm-4">
              <span>{{ $t("title.common.reservation_date") }}</span>
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              <div class="col-sm text-date">
                {{ item.start_date | dateformat("YYYY.MM.DD") }}
                {{ item.start_date | dateformat("HH:mm") }} ~
                {{ item.end_date | dateformat("HH:mm") }}
              </div>
            </div>

            <div class="col-sm-4">
              <span>{{ $t("title.common.peoples") }}</span>
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              {{ item.people }} {{ $t("text.common.people") }}
            </div>
            <div class="col-sm-4">
              {{ $t("title.common.type") }}
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              {{ item.type }}
            </div>
            <!-- <template v-if="item.type === 'hole'">
              <div class="col-sm-4">
                {{ $t("title.common.hole") }}
              </div>
              <div class="col-sm-8 d-flex flex-column flex-sm-row">
                {{ item.type }}
              </div>
            </template>

            <template v-if="item.type === 'hour'">
              <div class="col-sm-4">
                {{ $t("title.common.hour") }}
              </div>
              <div class="col-sm-8 d-flex flex-column flex-sm-row">
                {{ item.type }}
              </div>
            </template> -->

            <div class="col-sm-4">
              {{ $t("title.common.memo") }}
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              {{ item.memo || "-" }}
            </div>
          </div>
        </b-form>
      </template>
      <!-- 정상 완료 -->
      <template v-if="item.status == '2'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-success" style="font-size: 48px;">check_circle</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            Reservation Withdrawal completion
          </h6>
          <p class="pt-1 fs-14 lh-sm">Reservation Withdrawal success</p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">Nickname</div>
              <div class="col-sm-8">{{ item.nickname }}</div>

              <div class="col-sm-4 bg-transparent">
                {{ title.common.peoples }}
              </div>
              <div class="col-sm-8 text-price">
                {{ item.people }} {{ $t("text.common.people") }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("title.common.reservation_date") }}
              </div>
              <div class="col-sm-8">
                {{ item.start_date | dateformat("YYYY.MM.DD") }}
                {{ item.start_date | dateformat("HH:mm") }} ~
                {{ item.end_date | dateformat("HH:mm") }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 참가 제한 초과 -->

      <template #modal-footer>
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-reservation')"
        >
          {{ $t("button.common.close") }}
        </b-button>

        <b-button
          v-if="item.status == '1'"
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.withdrawal')"
          type="button"
          @click="set_reservation(item.rsv_pk)"
        >
          {{ $t("button.common.withdrawal") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import location from "@/components/Location";
import tab from "@/components/membership/Tab";
import ax from "@/api/membership";
import "@/filter/common";
import i18n from "@/i18n";

export default {
  name: "MyReservation",
  components: {
    location,
    tab,
  },
  data() {
    return {
      searchData: {
        pageno: parseInt(this.$route.query.page) || 1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "O.nickname",
      },
      item: {
        people: 1,
        date: this.$dayjs(new Date()).format("YYYY-MM-DD"),
        hole: 9,
        type: "hole",
        hour: 1,
        time: "",
        memo: "",
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      rsv_pk: null,
      view_hide: null,
    };
  },
  methods: {
    get_reservationlist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_reservationlist(this.searchData, (flag, data) => {
        this.total_cnt = data.reservationlistcnt;
        this.page_total = Math.ceil(data.reservationlistcnt / this.rows);
        this.items = data.reservationlist;
        if (!flag) alert(data.message);
      });
    },
    set_reservation(rsv_pk) {
      this.rsv_pk = rsv_pk;

      if (confirm(this.$i18n.t("text.membership.cancel_reservation"))) {
        ax.set_reservation(this.rsv_pk, (flag, data) => {
          alert(data.message);
          if (flag) {
            this.get_reservationlist();
            this.$bvModal.hide("modal-reservation");
          }
        });
      }
    },
    onSubmit(event) {
      event.preventDefault();
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    reservation_detail(item) {
      this.item = item;
      this.$bvModal.show("modal-reservation");
    },

    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_reservationlist();
  },
  watch: {
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.view_hide = null;
      this.get_reservationlist();
    },
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.view_hide = null;
      this.get_reservationlist();
    },
    "searchData.pageno": function () {
      this.view_hide = null;
      this.get_reservationlist();
    },
  },
};
</script>
<style>
.table-row {
  cursor: pointer;

  &:hover {
    background: #eaeaea;
  }
}
</style>